export default function getPageId(){
    return location.pathname.slice(1).split('/').slice(0, 3).join('/');
};
